export const getCurrent = ({ user, global, useGlobal }) => {
  return useGlobal ? global : user;
};
